module.exports = __webpack_public_path__ + "4ac5124fbf60fcff6808515904a79f04.svg";